import Decimal from 'decimal.js';

export function formatSignificant(decimal: Decimal, significantDigits = 3) {
  return decimal.toSignificantDigits(significantDigits).toString();
}
